import { render, staticRenderFns } from "./reward.vue?vue&type=template&id=45437ce7&scoped=true"
import script from "./reward.vue?vue&type=script&lang=js"
export * from "./reward.vue?vue&type=script&lang=js"
import style0 from "./reward.vue?vue&type=style&index=0&id=45437ce7&prod&lang=scss"
import style1 from "./reward.vue?vue&type=style&index=1&id=45437ce7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45437ce7",
  null
  
)

export default component.exports